import { useEffect } from 'react'
import { EnvironmentData, getEnvironmentData } from './get-environment-data'

const updateFavicon = (environmentData: EnvironmentData) => {
  // Store favicon URL in localStorage
  localStorage.setItem('app-favicon', environmentData.faviconHref)

  let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement
  if (!favicon) {
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    document.head.appendChild(favicon)
  }
  favicon.href = environmentData.faviconHref
}

const updatePageTitle = (environmentData: EnvironmentData) => {
  // Store title in localStorage
  localStorage.setItem('app-title', environmentData.pageTitle)
  document.title = environmentData.pageTitle
}

/**
 * Effects are stored in local storage to avoid flickering to no favicon or title when page is loaded.
 * When set in local storage, they're accessed by a script in the head of index.html, which loads and sets them before the main js script loads.
 * See the script tag in the head of index.html for more details.
 */
const effects = (environmentData: EnvironmentData) => () => {
  updateFavicon(environmentData)
  updatePageTitle(environmentData)
}

export const useEnvironmentDataEffects = () => {
  const environmentData = getEnvironmentData()
  const effect = effects(environmentData)
  useEffect(effect, [environmentData.name])
}
